import { z } from "zod";

export const topUpSchema = z.object({
  amount: z.coerce
    .number({ invalid_type_error: "Amount must be a number" })
    .int("Amount must be a whole number")
    .positive("Amount must be positive")
    .min(1, "Minimum amount is 1"),
});

export type TopUpFormData = z.infer<typeof topUpSchema>;
